<template>
  <div>
    <Head title="Perfil" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl uppercase text-gray-777 font-roboto">Perfil</h1>
      <form @submit.prevent="update" :multipart="true">
        <div class="flex flex-wrap mb-4 px-4">
          <photo-input v-model="form.photo" :error="form.errors[`photo.upload`]" class="pb-8 lg:pr-6 w-full lg:w-1/2"
            type="file" label="Foto" />
            <div class="pb-8 hidden lg:block lg:w-1/2"></div>
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 lg:pr-6 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 lg:pr-6 w-full lg:w-1/2"
            label="E-mail" />
          <text-input v-model="form.user_name" :error="form.errors.user_name" 
          class="pb-8 lg:pr-6 w-full w-full"
            label="Login" />

          <button v-if="!changePassword" type="button" 
          class="btn-primary font-normal text-xs px-6 py-2.5 "
            @click="changePassword = true">
            <font-awesome-icon icon="fa-lock" class="mr-2" /> Alterar senha
          </button>
          <password-input v-if="changePassword" v-model="form.password" 
          :error="form.errors.password"
            class="pb-8 lg:pr-6 w-full lg:w-1/2" label="Nova senha" />
          <password-input v-if="changePassword" v-model="form.password_confirmation"
            :error="form.errors.password_confirmation" class="pb-8 w-full lg:w-1/2" 
            label="Confirme a nova senha" />

        </div>
        <div class="flex justify-end">
          <loading-button :loading="form.processing" class="btn-purple " type="submit">Salvar</loading-button>
        </div>

        
      </form>
    </div>
    <div class="shadow_box rounded-lg p-6" style="margin-top: 5px;">
          <div class="flex flex-wrap mb-4 px-4">
            <WhatsappConection/>
          </div>
        </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import LoadingButton from '@/Shared/LoadingButton'
import MaskInput from '@/Shared/MaskInput'
import PhotoInput from '@/Shared/PhotoInput'
import WhatsappConection from './../WhatsappConection/WhatsappConect'


export default {
  components: {
    Head,
    LoadingButton,
    PhotoInput,
    TextInput,
    PasswordInput,
    MaskInput,
    WhatsappConection
  },
  props: {
    profile: Object,
  },
  remember: 'form',
  data() {
    return {
      changePassword: false,
      form: useForm({
        name: this.profile.name,
        user_name: this.profile.user_name,
        email: this.profile.email,
        password: '',
        photo: {
          name: this.profile.photo?.name,
          size: this.profile.photo?.size,
          url: this.profile.photo?.url,
        },
      })
    }
  },
  layout: Layout,
  methods: {
    update() {
      this.form.post('/profile', {
        forceFormData: true,
        onSuccess: () => {
          this.changePassword = false;
          this.form = useForm({
            photo: {
              name: this.profile.photo?.name,
              size: this.profile.photo?.size,
              url: this.profile.photo?.url,
            },
            name: this.profile.name,
            email: this.profile.email,
            user_name: this.profile.user_name,
            password: '',
          });
        },
      });
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
}
</script>
